import { computed, configure, makeAutoObservable } from 'mobx';
import { createContext, useContext } from 'react';

configure({
    enforceActions: 'never',
});

class ProviderStore {
    constructor() {
        makeAutoObservable(this);
    }

    rootStore: any = null;
    childStores = {};

    @computed get stores() {
        return {
            rootStore: this.rootStore,
            ...(this.childStores || {}),
        };
    }

    registerStore(name, store) {
        if (!this.childStores[name]) {
            this.childStores[name] = new store(this.rootStore);
        }
    }
}

export const initStore = (rootStore, childStores = {}) => {
    if (!rootStore) throw new Error('rootStore is required');

    const providerStore = new ProviderStore();

    providerStore.rootStore = new rootStore();

    Object.keys(childStores).forEach((name) => {
        providerStore.registerStore(name, childStores[name]);
    });

    const StoreContext = createContext<any>(providerStore.stores);

    return {
        StoreProvider: ({ children }) => (
            <StoreContext.Provider value={providerStore.stores}>{children}</StoreContext.Provider>
        ),
        registerStore(name, store) { providerStore.registerStore(name, store); },
        stores: providerStore.stores,
        useStores() {
            // store này sẽ chứa toàn bộ data
            const store = useContext(StoreContext);

            if (store === null) {
                throw new Error('Store cannot be null, please add a context provider');
            }

            return store;
        },
    };
};
